export const LOGIN_ERROR = "LOGIN_ERROR";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const CHANGE_PASS_REQ = "CHANGE_PASS_REQ";
export const LOGIN_SUCCESS_REMEMBER = "LOGIN_SUCCESS_REMEMBER";
export const RESET1_SUCCESS = "RESET1_SUCCESS";
export const RESET2_SUCCESS = "RESET2_SUCCESS";
export const LOGOUT = "LOGOUT";
export const IS_AUTH = "IS_AUTH";
export const REMOVE_FIRST_TIME = "REMOVE_FIRST_TIME";
